import React from 'react';
import { connect } from 'react-redux';
import NbReclamationsAffecteesIndicateur from './NbReclamationsAffecteesIndicateur';

import { fetchReclamationsAffecteesIfNeeded } from 'store/reclamation/indicateursActions';
import { resetRechercheCriteres } from 'store/reclamation/reclamationsActions';
import { updateRechercheCriteres } from 'store/reclamation/reclamationsActions';
import { setUtilisateurValue } from 'store/utilisateur/utilisateursActions';
import { clearFournisseurValue } from 'store/fournisseur/fournisseurActions';
import { clearTransporteurValue } from 'store/transporteur/transporteurActions';
import { clearClientValue } from 'store/client/clientActions';
import { clearSuggestionsArticleGestion } from 'store/articleGestion/articlesGestionActions';
import { clearAgenceValue } from 'store/agence/agenceActions';
import { clearUtilisateurValue } from 'store/utilisateur/utilisateursActions';
import { ReclamationFiltre } from 'constants.js';

class NbReclamationsAffecteesIndicateurContainer extends React.Component {

    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        this.props.fetchReclamationsAffecteesIfNeeded();
    }


    componentDidUpdate(prevProps) {
        if (this.props.didInvalidate && !prevProps.didInvalidate) {
            this.props.fetchReclamationsAffecteesIfNeeded();
        }
    }

    handleClick() {

        let utilisateur = JSON.parse(localStorage.getItem('utilisateur'));

        this.props.resetRechercheCriteres();
        this.props.clearFournisseurValue("searchFilters");
        this.props.clearTransporteurValue("searchFilters");
        this.props.clearClientValue("searchFilters");
        this.props.clearSuggestionsArticleGestion("searchFilters");
        this.props.clearAgenceValue();
        this.props.clearUtilisateurValue("searchFiltersUtilisateur");
        this.props.clearUtilisateurValue("searchFiltersEmetteur");
        this.props.clearUtilisateurValue("searchFiltersUtilisateurPreneurOrdre");
        this.props.clearUtilisateurValue("searchFiltersObservateur");
        

        this.props.setUtilisateurValue(`${utilisateur.codePO} - ${utilisateur.nom}`, utilisateur.id);

        this.props.updateRechercheCriteres({
            filtre: ReclamationFiltre.Toutes,
            utilisateurId: JSON.parse(localStorage.getItem('utilisateur')).id,
            dateCreationDebut: ``,
            dateCreationFin: ``
        });
    }

    render() {
        return <NbReclamationsAffecteesIndicateur isLoading={this.props.isLoading} count={this.props.valeur} onClick={this.handleClick} />;
    }
}

const mapStateToProps = state => ({
    valeur: state.reclamation.indicateurs.affectees.valeur,
    isLoading: state.reclamation.indicateurs.affectees.isLoading,
    didInvalidate: state.reclamation.indicateurs.creees.didInvalidate
});

const mapDispatchToProps = dispatch => ({
    fetchReclamationsAffecteesIfNeeded: () => dispatch(fetchReclamationsAffecteesIfNeeded()),
    updateRechercheCriteres: criteres => dispatch(updateRechercheCriteres(criteres)),
    setUtilisateurValue: (value, selectedId) => dispatch(setUtilisateurValue("searchFiltersUtilisateur", value, selectedId)),    
    resetRechercheCriteres: () => dispatch(resetRechercheCriteres()),

    clearFournisseurValue: (namespace) => dispatch(clearFournisseurValue(namespace)),
    clearTransporteurValue: (namespace) => dispatch(clearTransporteurValue(namespace)),
    clearClientValue: (namespace) => dispatch(clearClientValue(namespace)),
    clearSuggestionsArticleGestion: (namespace) => dispatch(clearSuggestionsArticleGestion(namespace)),
    clearUtilisateurValue: (namespace) => dispatch(clearUtilisateurValue(namespace)),
    clearAgenceValue: () => dispatch(clearAgenceValue())
});

export default connect(mapStateToProps, mapDispatchToProps)(NbReclamationsAffecteesIndicateurContainer);